import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ApiService from "@/shared/api";
import { onBeforeMount, onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import {
  TirPmNotificationEventBus,
  TirPmNotificationGroup,
  TirPmNotificationModel,
} from "tir-components";
import LoadingFilesWidget from "widgets/loading-files-widget";
import NotificationConnection from "widgets/notification-connection";
import NotificationConnectionVariantEnum from "./enums/NotificationConnectionVariantEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const api = new ApiService();
const router = useRouter();

/**Состояние коннекта с интернетом */
const stateConnect = ref<NotificationConnectionVariantEnum>();

/**
 * Выбросить юзера на авторизацию если его статус изменился
 */
onMounted(() => {
  api.Main.PerformersSaveService.SessionLogoutEventEvent.on(() => {
    console.log("LOGOUT EVENT");
    router.push("/login");
  });
  toggleSubscribe(true);
  document.addEventListener("test-manager-notification", testmanager);
});

/**Подписки */
const toggleSubscribe = (isSubscribe?: boolean) => {
  const windowFunc: keyof Window = isSubscribe
    ? "addEventListener"
    : "removeEventListener";

  window[windowFunc]("offline", () =>
    updateConnectionStatus(NotificationConnectionVariantEnum.Disconnected)
  );
  window[windowFunc]("online", () =>
    updateConnectionStatus(NotificationConnectionVariantEnum.Connected)
  );
  window[windowFunc]("focus", () => {
    setTimeout(() => {
      if (stateConnect.value === NotificationConnectionVariantEnum.Connected) {
        stateConnect.value = null;
      }
    }, 2000);
  });
};
onBeforeUnmount(() => {
  document.removeEventListener("test-manager-notification", testmanager);
});

function testmanager(event) {
  TirPmNotificationEventBus.emit("add", event.detail);
}
/**Обновить состояние соединения  */
const updateConnectionStatus = (state: NotificationConnectionVariantEnum) => {
  stateConnect.value = state;

  setTimeout(() => {
    if (stateConnect.value === NotificationConnectionVariantEnum.Disconnected) {
      stateConnect.value = NotificationConnectionVariantEnum.Reconnected;
    }
  }, 20000);
};
/**Закрыть уведомление */
const closeNotification = () => {
  stateConnect.value = null;
};

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterView),
    _createVNode(_unref(LoadingFilesWidget)),
    _createVNode(_unref(TirPmNotificationGroup), {
      group: "general",
      position: "top-right",
      zIndex: 20000
    }),
    _createVNode(_unref(NotificationConnection), {
      variant: stateConnect.value,
      onCloseNotification: closeNotification,
      onReconnect: _cache[0] || (_cache[0] = ($event: any) => (
      updateConnectionStatus(_unref(NotificationConnectionVariantEnum).Disconnected)
    ))
    }, null, 8, ["variant"])
  ], 64))
}
}

})